/* eslint-disable prettier/prettier */
import React from 'react';
import { Menu, Icon } from 'antd';
import moment from 'moment';
import 'moment/locale/es';
import { withTranslation } from 'react-i18next';
import { Logout } from 'correos-arq-auth';
import { storeArq } from 'correos-arq-utils';

var MUser = function MUser(myProps) {
  try {
    var t = myProps.t,
        logoutSys = myProps.logoutSys; // Coger fecha y hora del sistema actual

    var getDate = function getDate() {
      setInterval(function () {
        // @ts-ignore
        document.getElementById('hora').innerText = moment().locale('es').format('dddd, DD/MM/YYYY HH:mm:ss');
      }, 1000);
    };

    return (
      /*#__PURE__*/
      // @ts-ignore
      React.createElement("div", {
        className: "MUser",
        onLoad: getDate()
      }, /*#__PURE__*/React.createElement(Menu, null, /*#__PURE__*/React.createElement(Menu.Item, {
        key: "1",
        className: "datos"
      }, /*#__PURE__*/React.createElement("h4", null, storeArq.data.auth.userInfo.identificador), /*#__PURE__*/React.createElement("p", {
        id: "hora"
      }), /*#__PURE__*/React.createElement("p", null, storeArq.data.auth.userInfo.codired), /*#__PURE__*/React.createElement("p", null, storeArq.data.auth.userInfo.nombre, ' ', storeArq.data.auth.userInfo.apellidos), /*#__PURE__*/React.createElement("p", null, storeArq.data.auth.userInfo.rol)), /*#__PURE__*/React.createElement(Menu.Divider, null), /*#__PURE__*/React.createElement(Menu.Item, {
        key: "3",
        onClick: function onClick() {
          Logout(logoutSys);
        },
        className: "botones"
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "logout",
        color: "secondary",
        className: "iconoAuth"
      }), t('components_shared_MUser.logout'))))
    );
  } catch (error) {
    throw new Error("Error: ".concat(error));
  }
};

export default withTranslation()(MUser);